// extracted by mini-css-extract-plugin
export default {"swiper":"Swiper_swiper__RE9x0","swiperSlide":"Swiper_swiperSlide__EHVIi"};